<template>
  <OmtGrid class="refund-audit-page refund-audit-explanation">
    <OmtRow
      class="refund-audit-explanation__icon"
      :desktopStart="2"
      :desktopEnd="11"
      :mb="['16px', '20px']"
    >
      <OmtIcons
        name="file-magnifying-glass"
        color="var(--colors-light-primary-navy-blue)"
        size="2x"
      />
    </OmtRow>

    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
      mb="0"
    >
      <OmtTypography as="h1-bold"> Esta solicitação de reembolso encontra-se em auditoria </OmtTypography>
    </OmtRow>

    <OmtRow
      class="refund-audit-explanation__intro"
      :desktopStart="2"
      :desktopEnd="11"
      mb="16px"
    >
      <OmtTypography as="p1">
        Para a Omint, a transparência em nossa relação é fundamental. Portanto, gostaríamos de esclarecer o nosso
        processo de Auditoria Médico Administrativa. Neste momento, esta solicitação de reembolso encontra-se
        "Suspensa". Para dar continuidade à análise, será necessário fornecer informações e documentos adicionais que
        nos permitam verificar, conforme regras contratuais:
      </OmtTypography>
    </OmtRow>

    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
      :mb="['16px', '32px']"
    >
      <CBox
        class="refund-audit-rules"
        p="16px"
        border-radius="8px"
        bg="var(--colors-light-primary-light-gray)"
      >
        <CFlex>
          <OmtIcons
            w="18px"
            mr="20px"
            name="money-check-dollar-pen"
          />
          <CBox>
            <OmtTypography as="h3-semi-bold"> A data do pagamento das despesas </OmtTypography>
            <OmtTypography as="p2">
              Se o pagamento efetivo das despesas ocorreu <b>antes da data desta solicitação</b>.
            </OmtTypography>
          </CBox>
        </CFlex>

        <OmtDivider my="16px" />

        <CFlex>
          <OmtIcons
            w="18px"
            mr="20px"
            name="memo"
          />
          <CBox>
            <OmtTypography as="h3-semi-bold"> A descrição dos procedimentos </OmtTypography>
            <OmtTypography as="p2">
              Se a realização de <b>todos os procedimentos</b> está descrita na solicitação.
            </OmtTypography>
          </CBox>
        </CFlex>

        <OmtDivider my="16px" />

        <CFlex>
          <OmtIcons
            w="18px"
            mr="20px"
            name="location-dot"
          />
          <CBox>
            <OmtTypography as="h3-semi-bold"> O local da realização dos procedimentos </OmtTypography>
            <OmtTypography as="p2">
              Se o local escolhido é <b>habilitado e autorizado</b> para a execução os procedimentos realizados.
            </OmtTypography>
          </CBox>
        </CFlex>

        <OmtDivider my="16px" />

        <CFlex>
          <OmtIcons
            w="18px"
            mr="20px"
            name="memo-circle-check"
          />
          <CBox>
            <OmtTypography as="h3-semi-bold"> Os procedimentos realizados </OmtTypography>
            <OmtTypography as="p2">
              Se os procedimentos declarados correspondem aos <b>procedimentos efetivamente realizados</b>.
            </OmtTypography>
          </CBox>
        </CFlex>
      </CBox>
    </OmtRow>

    <OmtRow
      class="refund-audit-explanation__final"
      :desktopStart="2"
      :desktopEnd="11"
      :mb="['16px', '32px']"
    >
      <OmtTypography as="p1">
        É importante observar que evidências de uso indevido ou fornecimento de informações inverídicas
        <b> pode resultar no cancelamento do seu contrato.</b>
        Você pode solicitar o cancelamento desta solicitação de reembolso a qualquer momento e encerrar o processo de
        auditoria, sem acarretar qualquer implicação e eliminar a necessidade de fornecer informações e documentos
        complementares. Estamos à disposição para esclarecer qualquer dúvida que possa surgir durante esse processo.
      </OmtTypography>
    </OmtRow>

    <OmtRow
      :desktopStart="5"
      :desktopEnd="8"
    >
      <OmtButton
        class="refund-audit-explanation__continue"
        @click="sendToNext"
      >
        Continuar
      </OmtButton>
    </OmtRow>
  </OmtGrid>
</template>

<script>
export default {
  data() {
    return {
      dueDate: "",
      ticket: "",
      refund: ""
    };
  },
  mounted() {
    this.$root.$emit("hide-loading");

    if (this.$route.params.dueDate) this.dueDate = this.$route.params.dueDate;
    if (this.$route.params.ticket) this.ticket = this.$route.params.ticket;
    if (this.$route.params.refund) this.refund = this.$route.params.refund;

    if (!this.dueDate || !this.ticket || !this.refund) {
      this.$router.replace({
        path: "/refund-new/list"
      });
    }
  },
  methods: {
    sendToNext() {
      this.$router.replace({
        name: "refund.new.audit",
        query: this.$route.query,
        params: {
          dueDate: this.dueDate,
          ticket: this.ticket,
          refund: this.refund
        }
      });
    }
  }
};
</script>

<style scoped>
.refund-audit-page {
  align-content: start;
}

.refund-audit-rules {
  width: 100%;
}

.refund-audit-explanation__icon {
  padding-top: 8px;
}
.refund-audit-explanation__icon ::v-deep svg {
  width: 24px;
  height: 32px;
}
.refund-audit-explanation__intro {
  min-height: 184px;
}
.refund-audit-explanation ::v-deep p {
  line-height: 22px;
}
.refund-audit-rules {
  min-height: 373px;
}
.refund-audit-explanation__final {
  min-height: 280px;
}
.refund-audit-rules ::v-deep svg {
  flex: 0 0 16px;
  margin-right: 16px;
  height: 16px;
}
.refund-audit-rules ::v-deep h3 {
  margin-bottom: 4px;
}
.refund-audit-rules ::v-deep p {
  font-size: 12px;
  line-height: 18px;
}
.refund-audit-explanation__continue {
  font-size: 20px !important;
  line-height: 24px !important;
}

@media screen and (min-width: 1024px) {
  .refund-audit-page {
    max-width: 1104px;
  }

  .refund-audit-explanation__intro,
  .refund-audit-rules,
  .refund-audit-explanation__final {
    min-height: 0;
  }
}
</style>
